import React from "react";
import "./homePageInfo.style.scss";

const HomePageInfo = () => {
    return (
        <div>
            <div className="landing-info">
                <div className="landing-info-div">
                    <div className="landing-cover-image">
                    </div>
                    <p>
                        <strong>Learn</strong> how to do!
                    </p>
                </div>
                <div className="landing-info-div">
                    <div className="landing-cover-image">
                    </div>
                    <p>
                        <strong>Try</strong> and do it!
                    </p>
                </div>
                <div className="landing-info-div">
                    <div className="landing-cover-image">
                    </div>
                    <p>
                        <strong>Celebrate</strong> what you've done!
                    </p>
                </div>
            </div>
        </div>
    );
};

export default HomePageInfo;